import React from "react";
import EntityForm from "../EntityForm/EntityForm";
import { entityToFormValuesMapper } from "../../Common/utils";
import { DISPLAY, DISPLAY_FILTER_TYPE } from "../../Common/constants";
import multimediaTransform from "../../../../lib/multimediaTransform";
import { cloneDeep } from "lodash";

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });
  delete formValues.conditions;

  let entityFilter = fields.find(field => field.fieldName === "entityFilter").defaultValue;

  let tickerFilter = fields.find(field => field.fieldName === "tickerFilter").defaultValue;

  const entityFilterValue =
    entity.conditions &&
    entity.conditions.find(condition => condition.type === "ENTITY") &&
    entity.conditions.find(condition => condition.type === "ENTITY").value;
  /*
   * TODO: the entity filter selector should be a checkbox group
   * allowing multiple options selection.
   * */
  if (entityFilterValue) {
    if (entityFilterValue.indexOf("ALL") >= 0) {
      entityFilter = "ALL";
    } else if (entityFilterValue.indexOf(DISPLAY_FILTER_TYPE.ACCOMMODATION) >= 0) {
      entityFilter = DISPLAY_FILTER_TYPE.ACCOMMODATION;
    } else if (entityFilterValue.indexOf(DISPLAY_FILTER_TYPE.PROPERTY) >= 0) {
      entityFilter = DISPLAY_FILTER_TYPE.PROPERTY;
    }
  }

  const tickerFilterValue =
    entity.conditions &&
    entity.conditions.find(condition => condition.type === "TICKER") &&
    entity.conditions.find(condition => condition.type === "TICKER").value;
  if (tickerFilterValue) {
    tickerFilter = tickerFilterValue.join(",");
  }

  const isYoutubeVideo =
    entity.translations &&
    entity.translations.find(translation => translation.content.includes("VIDEO_DISPLAY_URL"));
  if (isYoutubeVideo) {
    const comment = isYoutubeVideo.content
      .split("\n")
      .find(content => content.includes("VIDEO_DISPLAY_URL"));
    const youTubeURL = comment.split(" ").find(data => data && data !== "<!--VIDEO_DISPLAY_URL");
    formValues.youTubeURL = youTubeURL;
    formValues.contentType = "VIDEO";
  }

  if (isYoutubeVideo) {
    formValues.translations = formValues.translations.map(translation => {
      const start =
        translation.content.indexOf("<!--DESCRIPTION_CONTENT_START-->") + 32;
      const end = translation.content.lastIndexOf("<!--DESCRIPTION_CONTENT_END-->");
      const content = translation.content.substring(start, end);
      return { ...translation, content: content };
    });
  }

  let originalMultimedia = cloneDeep(entity.multimedia) || [];
  let multimedia = [];

  if (entity.multimedia) {
    multimedia = multimediaTransform(entity.multimedia);
    formValues.contentType = multimedia.length > 0 ? "IMAGE" : formValues.contentType;
  }

  return {
    ...formValues,
    multimedia,
    originalMultimedia,
    entityFilter,
    tickerFilter,
  };
}

class DisplayForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  getYoutubeId = ({ youTubeURL }) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = youTubeURL.match(regExp);
    if (!match || !match.length) {
      return false;
    }
    const keyIdYoutube = match.length;
    return match && match[keyIdYoutube - 1].length === 11 && match[2];
  };

  getYouTubeURLValid = ({ youTubeURL }) => {
    if (youTubeURL) {
      const idVideo = this.getYoutubeId({ youTubeURL });

      if (idVideo) {
        return `<!--VIDEO_DISPLAY_URL ${youTubeURL} -->
          <span
            contenteditable="false"
            draggable="true"
            >
            <iframe 
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/${idVideo}?autoplay=1&loop=1&modestbranding=1&rel=0"
              frameborder="0"
              allowFullScreen="allowFullScreen"
            >
            </iframe>
          </span>`;
      }
    }
    return false;
  };

  handleSubmit({ formValues, entity: originalEntity }) {
    console.log("submitted ");
    const { config } = this.props;
    let htmlYouTubeURL = false;

    //TODO: handle case when there's an original entity
    //TODO: this could be handled in a generic way.
    const {
      id,
      entityFilter,
      tickerFilter,
      contentType,
      youTubeURL,
      ...otherFormValues
    } = formValues;
    const entity = {
      ...otherFormValues,
    };
    const conditions = [];

    if (contentType === DISPLAY.VIDEO) {
      htmlYouTubeURL = this.getYouTubeURLValid({ youTubeURL });
    }
    if (tickerFilter) {
      conditions.push({
        class: "stringComparison",
        value: tickerFilter.replace(/\s+/g, "").split(","),
        type: "TICKER",
        modifier: "INCLUDE",
      });
    }
    if (entityFilter) {
      conditions.push({
        class: "stringComparison",
        value: [entityFilter],
        type: "ENTITY",
        modifier: "INCLUDE",
      });
    }
    if (
      config.hasOwnProperty("translation") &&
      config.translation &&
      config.translation.hasOwnProperty("fieldName")
    ) {
      const translationField = config.translation.fieldName;
      const translationValues =
        (formValues.hasOwnProperty(translationField) && formValues[translationField]) || [];
      entity[config.translation.entityProperty] = translationValues.map(translation => {
        let localHtmlYouTubeURL;
        if (htmlYouTubeURL) {
          localHtmlYouTubeURL = htmlYouTubeURL.concat(`</span>
          <!--TITLE_CONTENT_START-->
          <div style="color: rgb(34, 34, 34);
                      font-size: 20px;
                      font-weight: 600;
                      text-transform: uppercase;
                      text-align: left;
                      margin-top: 15px;
                      margin-bottom: 10px;
                      ">
          ${translation.label}</div>
          <!--TITLE_CONTENT_END-->
          <!--DESCRIPTION_CONTENT_START-->
          <div>
            ${translation.content}
          </div>
          <!--DESCRIPTION_CONTENT_END-->`);
        }
        return {
          locale: translation.locale,
          label: translation.label,
          content: localHtmlYouTubeURL ? localHtmlYouTubeURL : translation.content,
        };
      });
    }
    entity.conditions = conditions;
    if (id !== "" && id !== " " && id !== null && typeof formValues.id !== "undefined") {
      entity.id = formValues.id;
    }

    if (formValues.entityFilter === DISPLAY_FILTER_TYPE.PROPERTY) {
      entity.conditions = entity.conditions.filter(it => it.type !== "TICKER");
    }

    const data = new FormData();
    if (formValues.contentType === DISPLAY.IMAGE && formValues.imageManager) {
      const remainingIds = formValues.imageManager.map(it => it.id);

      entity.multimedia = entity.originalMultimedia.filter(it => remainingIds.includes(it.id));

      formValues.imageManager.forEach(file => {
        if (file.new) {
          const fileExtension = file.name.split(".").pop();

          entity.multimedia.push({
            id: file.id,
            filename: `${file.id}.${fileExtension}`,
          });

          data.append("images", file, `${file.id}.${fileExtension}`);
        }
      });
    } else if (formValues.contentType === DISPLAY.IMAGE) {
      entity.multimedia = entity.originalMultimedia;
    } else {
      delete entity.multimedia;
    }

    delete entity.imageManager;
    delete entity.originalMultimedia;

    data.append(
      "entity",
      new Blob([JSON.stringify(entity)], {
        type: "application/json",
      })
    );

    this.props.onSubmitEntity({
      entity: data,
    });
  }

  /* Handle Errors */
  render() {
    const { name, validation, fields, renderers, translation, entities} = this.props.config;
    const { locales, entity, entityError, entityResult, loading, getListPath } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        getListPath={getListPath}
        entityToFormValuesMapper={customEntityToFormValuesMapper}
        allowDeleteSelection={true}
      />
    );
  }
}

DisplayForm.propTypes = {};

DisplayForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
};

export default DisplayForm;
